import servers from "./servers";

export default {
  [servers.user]: "https://devpuser-api.jilingshu.com.cn",
  [servers.exam]: "https://devpexam-center-service.jilingshu.com.cn",
  [servers.device]: "https://devpapi.jilingshu.com.cn",
  [servers.authorization]: "https://devpapi.jilingshu.com.cn",
};
